import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";
import { STORE_CONFIG } from "../config/store";
import { POLICY_LINKS } from "../config/policyLinks";

const footerLinks = [
  ["Contact Us", "/contact"], [`About ${STORE_CONFIG.brand}`, "/about"],
  ...POLICY_LINKS,
];

function Footer() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-top">
        <div className="footer-column">
          <h3 className="footer-heading">{STORE_CONFIG.brand}</h3>
          <p className="region-label">Operating region: {STORE_CONFIG.operatingRegion}</p>
          <p className="footer-contact"><a href={`mailto:${STORE_CONFIG.supportEmail}`} className="email-link">{STORE_CONFIG.supportEmail}</a></p>
        </div>
        <div className="footer-column">
          <ul className="footer-links">
            {footerLinks.map(([label, path]) => <li key={path}><Link to={path} onClick={toTop}>{label}</Link></li>)}
          </ul>
        </div>
        <div className="footer-column payment-column">
          <p className="payment-heading">Payment</p>
          <div className="payment-method" aria-label={STORE_CONFIG.paymentMethodLabel}>
            <svg viewBox="0 0 42 28" aria-hidden="true"><rect x="1" y="1" width="40" height="26" rx="4" /><path d="M1 9h40M7 20h11" /></svg>
            <span>{STORE_CONFIG.paymentMethodLabel}</span>
          </div>
          <p className="payment-note">Payment details are entered on the hosted checkout page.</p>
        </div>
      </div>
      <div className="footer-bottom"><div className="copyright">Copyright © 2026 {STORE_CONFIG.brand}</div></div>
    </footer>
  );
}

export default Footer;
